module.exports = __webpack_public_path__ + "img/report-sample-01@3x.6eb24e74.png";